module.exports = __webpack_public_path__ + "images/0b078e086939e599335694a1ef561ea2.png";